import {useState} from "react";
import {useTranslation} from "react-i18next";
import {Stack, styled, Switch} from "@mui/material";

const SwitchStyled = styled(Switch)(() => ({
  marginLeft: 0,
  "& .MuiSwitch-input": {
    width: "300%",
    height: "100%",
  },
}));

const LanguageSwitch = ({setLanguage, disabled = false}) => {
  const {
    i18n: {language},
  } = useTranslation();

  // const nonEnglishLanguage = language === "en" ? "UA" : language === "uk" ? "UA" : language;
  const [checked, setChecked] = useState(language === "en");

  const firstLanguage = language;
  const secondLanguage = language === "en" ? "uk" : language === "uk" ? "en" : language;
  const displayLanguage = language => (language === "en" ? "ENG" : language === "uk" ? "UA" : language);

  const handleChange = event => {
    const isChecked = event.target.checked;
    setLanguage(isChecked ? secondLanguage : firstLanguage);
    setChecked(isChecked);
  };

  return (
    <div>
      <Stack direction="row" spacing={0.3} alignItems="center">
        <p id="checkFontSize">{displayLanguage(firstLanguage)}</p>
        <SwitchStyled checked={checked} onChange={handleChange} disabled={disabled} />
        <p>{displayLanguage(secondLanguage)}</p>
      </Stack>
    </div>
  );
};

export default LanguageSwitch;
